// extracted by mini-css-extract-plugin
var _1 = "dataIntegration_copy";
var _2 = "dataIntegration_top-wrapper";
export { _1 as "copy", _2 as "top-wrapper" }
